import styled from 'styled-components';
import { breakpoints } from 'themes/breakpoints.theme';

const Container = styled.div`
    display: flex;
    flex-direction: column;
    @media screen and (min-width: ${breakpoints.md}){
        flex-direction: row;
    }
`;

const LeftCol = styled.div`
    flex: 1;
    padding: 20px;
    @media screen and (min-width: ${breakpoints.md}){
        flex-direction: row;
        padding: 32px;
    }
    @media screen and (min-width: ${breakpoints.lg}){
        padding: 56px;
    }
    p{
        font-family: Overpass;
    font-size: 24px;
    font-weight: 300;
    font-stretch: normal;
    font-style: normal;
    line-height: 1.4;
    letter-spacing: normal;
    color: #000000;
    position: relative;
    text-align: left;

    }
`;
const RightCol = styled.div`
    flex: 1;
    position: relative;
    overflow: hidden;
    background-color: #c4c4c4;
    @media screen and (min-width: ${breakpoints.s}){
    min-height: 450px;
    }
    img {
        position: relative;
    width: 100%;
    height: auto;
    display: block;
        @media screen and (min-width: ${breakpoints.xs}){
            width: 100%;
             height: 100%;
            object-fit: cover;
        }
    }

`;

const Header = styled.div`
    font-family: Anton;
    font-size: 37px;
    font-weight: normal;
    text-transform: uppercase;
    letter-spacing: 0;
`;

const Cta = styled.a`
    display: inline-flex;
    justify-content: center;
    align-items: center;
    font-family: Overpass;
    font-style: normal;
    font-weight: bold;
    line-height: 18px;
    transition: all 0.2s ease;
    text-transform: uppercase;
    text-decoration: none;
    background: #001EFF;
    color: #fff;
    min-height: 40px;
    padding: 8px 16px;
    margin-right: 20px;;
    font-size: 12px;

    img {
        width: 16px;
        margin-left: 8px;
    }

    &:hover {
        background: #0018CC;
    }
`;

export { Container, LeftCol, RightCol, Header, Cta };